module.exports = __webpack_public_path__ + "img/icon03.3fccfa41.svg";